module.exports = __webpack_public_path__ + "static/media/05.4dc6128c.jpg";